import PropTypes from 'prop-types'

import { apolloClient } from 'lib/withApollo'
import CATEGORIES_QUERY from 'graphql/categories.query'
import POSTS_QUERY from 'graphql/posts.query'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import uppercaseFirst from 'helpers/uppercaseFirst'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import NewsHeader from 'components/NewsHeader'
import ArticleGrid from 'components/ArticleGrid'
import Pagination from 'components/Pagination'

function Category({
  offsetPagination,
  globalSettings,
  categorySlug,
  site,
  posts,
  categoriesMenu,
}) {
  return (
    <Layout globalSettings={globalSettings}>
      <WordpressSEO
        url={`/${site}/news/${categorySlug}`}
        title={uppercaseFirst(categorySlug)}
        desc="Latest news from our talent and models at Select Model London. Select Model Management is an iconic global network of boutique model and talent agencies."
        image={posts?.[0]?.acfPost?.featuredImage?.mediaItemUrl}
      />
      <NewsHeader categorySlug={categorySlug} categories={categoriesMenu} />
      <ArticleGrid articles={posts} />
      <Pagination pagination={offsetPagination} currentPage={1} />
    </Layout>
  )
}

Category.propTypes = {
  globalSettings: PropTypes.object,
}
Category.defaultProps = {
  globalSettings: {},
}

export default Category

export async function getStaticProps({ params }) {
  const { site, categorySlug } = params

  const { data, error } = await apolloClient().query({
    query: POSTS_QUERY,
    context: { site },
    variables: {
      categoryName: categorySlug,
      withCategoriesMenu: true,
      featuredInBlocks: true,
    },
  })

  if (error) console.log(`Error loading News Category props - ${error}`)

  return {
    props: {
      ...params,
      posts: data.posts.nodes,
      categoriesMenu: data.pageBy.acfNews.categoriesMenu,
      offsetPagination: data.posts.pageInfo.offsetPagination,
    },
    revalidate: 60 * 10,
  }
}

export async function getStaticPaths() {
  const sites = await getSitesForStaticPaths(
    ({ site }) => ({
      query: CATEGORIES_QUERY,
      context: { site },
    }),
    (data) =>
      data.categories.nodes
        .filter((c) => c.slug !== 'uncategorised')
        .map((c) => c.slug)
  )
  const paths = []
  sites.forEach((site) => {
    site[1].forEach((p) =>
      paths.push({
        params: {
          site: site[0],
          categorySlug: p,
        },
      })
    )
  })

  return {
    paths,
    fallback: false,
  }
}
